import { render } from "./PageTitleSpecificBrand.vue?vue&type=template&id=dff951c8"
import script from "./PageTitleSpecificBrand.vue?vue&type=script&lang=js"
export * from "./PageTitleSpecificBrand.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageTitleSpecificBrand.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dff951c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dff951c8', __exports__)) {
    api.reload('dff951c8', __exports__)
  }
  
  module.hot.accept("./PageTitleSpecificBrand.vue?vue&type=template&id=dff951c8", () => {
    api.rerender('dff951c8', render)
  })

}


export default __exports__